import { PerformanceDatapoint } from './PerformanceDatapoint';
import type {
    DatapointOptions,
    INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT,
} from 'owa-analytics-types';
import type { AnalyticsCoreEventNames, AnalyticsEventNames } from 'owa-analytics-events';
import type { MailboxInfo } from 'owa-client-types';

export default class VerboseDatapoint extends PerformanceDatapoint {
    constructor(
        eventName: AnalyticsEventNames | AnalyticsCoreEventNames,
        mailbox: MailboxInfo | typeof INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT | undefined,
        options?: DatapointOptions
    ) {
        const verboseDatapointOptions: DatapointOptions = { ...(options ? options : {}) };

        verboseDatapointOptions.isVerbose = true;

        super(eventName, mailbox, verboseDatapointOptions);
    }
}
